import { Menu, MenuProps } from '@mui/material';
import { ReactNode } from 'react';
import { AgButton, AgTooltip } from 'src/components/ui';
import useAnchorEl from 'src/hooks/useAnchorEl';

type MenuDropDownProps = { icon: ReactNode; children: ReactNode; hint?: string; label?: string } & Omit<
  MenuProps,
  'open'
>;

export function MenuDropDown({ icon, children, hint, label, ...menuProps }: MenuDropDownProps) {
  const { ref, anchorEl, open, handleOpen, handleClose } = useAnchorEl();
  const isIconOnly = !label;

  const button = (
    <AgButton ref={ref} onPress={handleOpen} variant="white" size={isIconOnly ? 'icon-sm' : 'sm'} shape="rounded">
      {icon}
      {label && <span className="ml-2">{label}</span>}
    </AgButton>
  );

  return (
    <>
      {hint && isIconOnly ? <AgTooltip content={hint}>{button}</AgTooltip> : button}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} {...menuProps}>
        {children}
      </Menu>
    </>
  );
}
